import "./attachments.css";

const AttachmentCard = ({ item }) => {
  return (
    <div className="grid lg:grid-cols-9 grid-cols-1 lg:py-[69px] sm:py-[40px] py-[20px]">
      <div
        className="lg:h-auto h-[250px] lg:col-span-4 col-span-1 bg-no-repeat bg-center bg-contain bg-white border-t border-x lg:border-t lg:border-b lg:border-l lg:border-r-0 border-[#292929] overflow-hidden bg-[image:var(--image-url)]"
        style={{
          "--image-url": `url(${item.img})`,
          boxShadow: "0px 4px 4px 0px #00000040",
        }}
      ></div>
      <div className="lg:col-span-5 col-span-1">
        <div
          className="2xl:px-[72px] lg:px-[50px] md:px-[30px] px-[20px] py-[45px] bg-[#F2F2F2] border-y-[1px] border-r-[1px] lg:border-l-[1px] border-l-[1px] border-[#292929] h-full flex flex-col justify-between"
          style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
        >
          <div>
            <div className="2xl:text-[30px] xl:text-[27px] lg:text-[25px] md:text-[20px] sm:text-[18px] text-[16px] font-bold font-[Roboto]">
              {item.title}
            </div>
            <div className="2xl:text-[27px] xl:text-[25px] lg:text-[20px] md:text-[18px] sm:text-[16px] text-[14px] font-normal font-[Roboto] mt-[25px]">
              {item.subTitle}
            </div>
          </div>

          <div className="flex justify-between mt-[35px] flex-col 2xl:flex-row gap-4">
            <button
              className="rounded-lg bg-[#7ABF5B] text-[#fff] py-[15px] font-[Roboto] font-bold text-center 2xl:text-[24px] xl:text-[24px] lg:text-[20px] md:text-[18px] sm:text-[16px] text-[14px] lg:px-[80px] px-[20px] lg:w-auto w-full max-h-[85.5px]"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            >
              VIEW DETAILS
            </button>

            <div className="2xl:text-end text-left 2xl:mt-0 mt-[10px]">
              <div className="2xl:text-[27px] xl:text-[25px] lg:text-[20px] md:text-[18px] sm:text-[16px] text-[14px] font-[Roboto] font-normal 2xl:max-w-[293px] w-full">
                Suitable for {item.Suitable}
              </div>
              <div className="2xl:text-[30px] xl:text-[27px] lg:text-[25px] md:text-[20px] sm:text-[18px] text-[16px] font-[Roboto] font-bold">
                {item.modelNo}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AttachmentCard;
